const BIG_IMAGE_WITH_TABS_BLOCK_TAPE_TRANSFER = {
  titlesList: [
    {
      id: 1,
      text: '',
      textMob: '',
      secondText: 'Professional Tape Transfer',
      secondTextMob: 'Professional Tape',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: true,
      isLeft: true,
      isLeftMob: true,
      isRight: false,
      isRightMob: false,
      color: '#fff',
      colorMob: '#fff',
      isTextWithLine: true,
      isTextWithLineMob: true,
      isSecondTextWithLine: true,
      isSecondTextWithLineMob: true,
      firstTextLines: [],
      secondTextLines: [],
    },
    {
      id: 2,
      text: 'Services.',
      textMob: 'Transfer.',
      secondText: '',
      secondTextMob: '',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: false,
      isLeft: false,
      isLeftMob: true,
      isRight: true,
      isRightMob: false,
      color: '#fff',
      colorMob: '#fff',
      isTextWithLine: true,
      isTextWithLineMob: true,
      isSecondTextWithLine: true,
      isSecondTextWithLineMob: true,
      firstTextLines: [{
        id: 1,
        isLeftLine: true,
        isRightLine: false,
        isTopLine: false,
        isBottomLine: false,
        color: '#fff',
        isLineWithSquare: true,
        isLeftLineMob: false,
        isRightLineMob: true,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#fff',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
  ],
  tabs: [
    {
      key: 'first-tab',
      tabTitle: 'first tab',
      tabTitleMobile: 'first tab',
      mediaData: '',
      title: '',
      description: '',
      buttonText: '',
      buttonLink: '',
      withPrice: false,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per tape',
    },
    {
      key: 'second-tab',
      tabTitle: 'second tab',
      tabTitleMobile: 'second tab',
      mediaData: '',
      title: '',
      description: '',
      buttonText: '',
      buttonLink: '',
      withPrice: false,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per tape',
    },
    {
      key: 'third-tab',
      tabTitle: 'third tab',
      tabTitleMobile: 'third tab',
      mediaData: '',
      title: '',
      description: '',
      buttonText: '',
      buttonLink: '',
      withPrice: false,
      price: 0,
      additionalDiscount: 0,
      perText: 'Per tape',
    },
  ],
};

export default BIG_IMAGE_WITH_TABS_BLOCK_TAPE_TRANSFER;
